export const TechnologyHighlightsConstants = {
    ALL_TECHNOLOGY_HIGHLIGHTS_GROUP_ID: -1,
    ALL_TECHNOLOGY_HIGHLIGHTS_GROUP_NAME: "All"
} as const;